export const msTabsData =
[ // 탭 data
  {
    id: '1',
    title: '멤버십',
    name: '1',
    path: '/ms/msb/SCR_MSB_0001'
  },
  {
    id: '2',
    title: '매장 위치 찾기',
    name: '2',
    path: '/ms/msg/SCR_MSG_0019'
  },
  {
    id: '3',
    title: '매장 상품 찾기',
    name: '3',
    path: '/ms/msg/SCR_MSG_0015'
  }
]

export const prdList =
[
  { id: '1', title: '최근 1개월', label: '1' },
  { id: '3', title: '최근 3개월', label: '3' },
  { id: '6', title: '최근 6개월', label: '6' },
  { id: '12', title: '최근 1년 ', label: '12' }
]

export default {
  msTabsData,
  prdList
}
